import { jsx } from "panel";
import debounce from "lodash/debounce";
import { ButtonEl } from "common/components/button";
import { ButtonSize, ButtonTheme } from "common/components/button/constants";
import { SvgIconEl } from "common/components/svg-icon";
import { InputEl } from "common/components/input";
import { toCurrency } from "media/js/pricing/plan-builder-2023/common/util";
import { TrackingEvents } from "media/js/pricing/tracking";
import inputStyleOverride from "./input-marketing.inline.styl";
export function template() {
  var _a, _b, _c, _d, _e;
  const selectedCapString = this.app.helpers.getSelectedCapAbbreviated();
  const billingPeriod = this.app.helpers.getBillingPeriodString();
  const selectedPlanPrice = (_b = (_a = this.app.state) == null ? void 0 : _a.amountDueInfo) == null ? void 0 : _b.amount;
  const showNotChargedToday = ((_c = this.app.state) == null ? void 0 : _c.amountDueInfo) && ((_e = (_d = this.app.state) == null ? void 0 : _d.amountDueInfo) == null ? void 0 : _e.amount) === 0;
  const { showEmailInput, emailValidationError, emails, purchaseBtnLoading } = this.state;
  const { billingCard } = this.app.state;
  const overagePrice = this.app.helpers.getOveragePricePerEventString();
  const renderDetails = () => {
    return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
      sel: ".step-title"
    }, "Confirm your details"), /* @__PURE__ */ jsx("div", {
      sel: ".section-title.bold"
    }, "Plan"), /* @__PURE__ */ jsx("div", {
      sel: ".section-description"
    }, selectedCapString, " Event volume per month"), /* @__PURE__ */ jsx("div", {
      sel: ".section-caption"
    }, overagePrice && /* @__PURE__ */ jsx("span", null, "Additional events will be charged at ", overagePrice, " and billed the following month.")), /* @__PURE__ */ jsx("div", {
      sel: ".section-title.bold"
    }, "Billing Period"), /* @__PURE__ */ jsx("div", {
      sel: ".section-description"
    }, billingPeriod), /* @__PURE__ */ jsx("div", {
      sel: ".section-caption"
    }, "Renews: ", this.app.helpers.getRenewalDate()), /* @__PURE__ */ jsx("div", {
      sel: ".section-title.bold"
    }, "Payment"), billingCard && /* @__PURE__ */ jsx("div", {
      sel: ".section-description"
    }, /* @__PURE__ */ jsx("div", null, `${billingCard.type} \xB7\xB7\xB7\xB7 \xB7\xB7\xB7\xB7 \xB7\xB7\xB7\xB7 ${billingCard.last4}`), /* @__PURE__ */ jsx("div", null, "Expires ", `${billingCard.expiryMonth}/${billingCard.expiryYear}`)));
  };
  return /* @__PURE__ */ jsx("div", {
    sel: ".review-wrapper"
  }, this.attr(`mp-2023-style`) ? renderDetails() : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx("div", {
    sel: ".step-title"
  }, "Plan Summary"), /* @__PURE__ */ jsx("div", {
    sel: ".plan-info"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `checkmark` },
    sel: ".checkmark-icon"
  }), /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx("span", {
    sel: ".mp-font-size-large"
  }, "Mixpanel Plan: "), " ", selectedCapString, " Event volume per month")), /* @__PURE__ */ jsx("div", {
    sel: ".plan-info"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `checkmark` },
    sel: ".checkmark-icon"
  }), /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx("span", {
    sel: ".mp-font-size-large"
  }, "New Plan Term: "), " ", billingPeriod)), /* @__PURE__ */ jsx("div", {
    sel: ".step-description"
  }, overagePrice && /* @__PURE__ */ jsx("span", null, "Additional data (Events) will be charged at ", overagePrice, " and billed the following month."))), /* @__PURE__ */ jsx("div", {
    sel: ".payment-method-section"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".step-title"
  }, "Payment Method"), billingCard && /* @__PURE__ */ jsx("div", {
    sel: ".step-description"
  }, /* @__PURE__ */ jsx("div", null, `${billingCard.type} \xB7\xB7\xB7\xB7 \xB7\xB7\xB7\xB7 \xB7\xB7\xB7\xB7 ${billingCard.last4}`), /* @__PURE__ */ jsx("div", null, "Expires ", `${billingCard.expiryMonth}/${billingCard.expiryYear}`)))), !showEmailInput && /* @__PURE__ */ jsx("div", {
    sel: ".send-recipients-wrapper",
    on: {
      click: () => {
        this.helpers.setShowEmailInput(true);
      }
    }
  }, /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `email` }
  })), /* @__PURE__ */ jsx("div", {
    sel: ".send-recipients-text"
  }, `Send billing receipts to additional team members ${emails && `(${emails})`}`)), showEmailInput && /* @__PURE__ */ jsx("div", {
    sel: ".emails-input-area"
  }, /* @__PURE__ */ jsx(InputEl, {
    attrs: {
      placeholder: `List of emails separated by comma`,
      "auto-focus": true,
      ...emailValidationError && { "validation-status": `invalid`, "error-message": emailValidationError },
      "style-override": this.attr(`mp-2023-style`) ? inputStyleOverride : ``
    },
    on: {
      input: debounce((ev) => {
        this.helpers.setEmailRecipients(ev.target.value);
      }, 300),
      focus: () => {
        if (emails) {
          const emailsInput = document.querySelector(`mp-input`);
          emailsInput.value = emails;
        }
      }
    }
  }), /* @__PURE__ */ jsx(ButtonEl, {
    attrs: {
      theme: this.attr(`mp-2023-style`) ? ButtonTheme.MarketingSecondary : ButtonTheme.Secondary,
      role: `button`,
      tabindex: 0
    },
    sel: ".cancel-btn",
    on: {
      click: () => {
        this.helpers.setEmailValidationError(null);
        this.helpers.setShowEmailInput(false);
      }
    }
  }, "Cancel"), /* @__PURE__ */ jsx(ButtonEl, {
    attrs: {
      theme: this.attr(`mp-2023-style`) ? ButtonTheme.MarketingPrimary : ButtonTheme.Primary,
      role: `button`,
      tabindex: 0
    },
    sel: ".save-btn",
    on: { click: this.helpers.handleInputGroupSubmit }
  }, "Save")), this.attr(`mp-2023-style`) && showNotChargedToday && /* @__PURE__ */ jsx("div", {
    sel: ".info-icon-area"
  }, /* @__PURE__ */ jsx("span", null, "Your card will not be charged today, but we do require a card on file.")), /* @__PURE__ */ jsx("div", {
    sel: ".review-btn-area"
  }, /* @__PURE__ */ jsx(ButtonEl, {
    attrs: {
      theme: this.attr(`mp-2023-style`) ? ButtonTheme.MarketingPrimary : ButtonTheme.Primary,
      role: `button`,
      tabindex: 0,
      disabled: purchaseBtnLoading,
      size: ButtonSize.Large
    },
    on: {
      click: () => {
        if (!purchaseBtnLoading) {
          this.app.state.customerInfo.orgInfo.arr ? this.helpers.changePlan() : this.helpers.purchasePlan();
        }
      }
    }
  }, `${purchaseBtnLoading ? `Processing` : `Complete Purchase ${toCurrency(selectedPlanPrice)}`}`), this.attr(`mp-2023-style`) && /* @__PURE__ */ jsx("a", {
    sel: ".support-btn",
    attrs: {
      role: `button`,
      tabindex: 0,
      href: `/get-support`,
      target: `_blank`
    },
    on: { click: () => this.app.helpers.trackEventWithPlanProps(TrackingEvents.ContactSupport) }
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `brand-help` }
  }), "Contact support"), !this.attr(`mp-2023-style`) && showNotChargedToday && /* @__PURE__ */ jsx("div", {
    sel: ".info-icon-area"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `info` },
    sel: ".info-icon"
  }), /* @__PURE__ */ jsx("span", null, "Your card will not be charged today, but we do require a card on file."))));
}
